/*
 * Admin area to edit survey rating labels.  Each set of labels is shown in a list broken down by language.
 */

define([
  "marionette",
  "underscore",
  "messaging/messenger",
  "./surveyLabelDisplayView",
  "modules/accountAdmin/kbProfile/surveyLabels/surveyLabelsModel",
], function (Marionette, _, Messenger, SurveyLabelDisplayView) {
  var SurveyLabelDisplayController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "surveyLabels";
      this.region = options.region;
      this.kb = options.model;
      this._setUpVents();
    },
    show: function (touchPointId) {
      this.labelsCol = Messenger.reqres.request("survey:labels", touchPointId);

      Messenger.onSave(function () {
        console.log("saving survey label configuration");
        this.labelsCol.saveCollection();
      }, this);

      //grab the languages
      var languageCol = this.kb.getLocales();
      this.labelsCol.languages = languageCol;
      //wait until the labels and languages have synced
      this.labelsCol.onSynced(function () {
        languageCol.onSynced(function () {
          //add in any missing labels by language
          this._prepareLabels(touchPointId);
          this.view = new SurveyLabelDisplayView.surveyLabels({ collection: this.labelsCol });
          this.showRegion(this.view);
        }, this);
      }, this);
    },
    _prepareLabels: function (touchPointId) {
      //check if there are any languages in labelsCol that are not in the kb languages list.
      var languages = this.labelsCol.languages.pluck("id");
      var excludedLabels = this.labelsCol.filter(function (labels) {
        return !_.contains(languages, labels.id);
      });
      this.labelsCol.remove(excludedLabels);
      //check if there are any language in the kb languages list which are not in labelsCol
      _.each(
        languages,
        function (languageId) {
          if (!this.labelsCol.findWhere({ languageId: languageId })) {
            //create a new labels model for the missing language
            this.labelsCol.addLabels(languageId, touchPointId);
          }
        },
        this,
      );
    },
    _setUpVents: function () {
      //Whenever a different touchPoint is selected, we re-initialize the show method,
      //with the new touchPoint. This will refresh the module appropriately.
      Messenger.vent.on(
        "change:selected:touchPoint",
        function (newTouchPointId) {
          console.log("changing touchpoint to: " + newTouchPointId);
          //save old stuff
          //display new stuff
          this.labelsCol.onSynced(function () {
            this.show(newTouchPointId);
          }, this);
        },
        this,
      );
      Messenger.vent.on(
        "refresh:kb:response:settings",
        function (updatedKb) {
          this.kb = updatedKb;
        },
        this,
      );
    },
  });

  return SurveyLabelDisplayController;
});
